/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExposureStatus } from './ExposureStatus';
import {
    ExposureStatusFromJSON,
    ExposureStatusFromJSONTyped,
    ExposureStatusToJSON,
} from './ExposureStatus';
import type { GrowthAllocationType } from './GrowthAllocationType';
import {
    GrowthAllocationTypeFromJSON,
    GrowthAllocationTypeFromJSONTyped,
    GrowthAllocationTypeToJSON,
} from './GrowthAllocationType';
import type { ReportStage } from './ReportStage';
import {
    ReportStageFromJSON,
    ReportStageFromJSONTyped,
    ReportStageToJSON,
} from './ReportStage';

/**
 * 
 * @export
 * @interface GrowthAllocationEnriched
 */
export interface GrowthAllocationEnriched {
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    targetGrowthSleeve?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    actualUnencumberedCash?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    currentLeverageRatio?: number;
    /**
     * 
     * @type {GrowthAllocationType}
     * @memberof GrowthAllocationEnriched
     */
    allocationType: GrowthAllocationType;
    /**
     * 
     * @type {ExposureStatus}
     * @memberof GrowthAllocationEnriched
     */
    exposureStatus?: ExposureStatus;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    currentWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    targetWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    activeWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    currentExposure?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    targetExposure?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationEnriched
     */
    activeExposure?: number;
    /**
     * 
     * @type {string}
     * @memberof GrowthAllocationEnriched
     */
    tradeDate: string;
    /**
     * 
     * @type {ReportStage}
     * @memberof GrowthAllocationEnriched
     */
    reportStage: ReportStage;
    /**
     * 
     * @type {string}
     * @memberof GrowthAllocationEnriched
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof GrowthAllocationEnriched
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof GrowthAllocationEnriched
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof GrowthAllocationEnriched
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof GrowthAllocationEnriched
     */
    referencePortfolio?: string;
}



/**
 * Check if a given object implements the GrowthAllocationEnriched interface.
 */
export function instanceOfGrowthAllocationEnriched(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "allocationType" in value;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "reportStage" in value;
    isInstance = isInstance && "pId" in value;

    return isInstance;
}

export function GrowthAllocationEnrichedFromJSON(json: any): GrowthAllocationEnriched {
    return GrowthAllocationEnrichedFromJSONTyped(json, false);
}

export function GrowthAllocationEnrichedFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrowthAllocationEnriched {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetGrowthSleeve': !exists(json, 'target_growth_sleeve') ? undefined : json['target_growth_sleeve'],
        'actualUnencumberedCash': !exists(json, 'actual_unencumbered_cash') ? undefined : json['actual_unencumbered_cash'],
        'currentLeverageRatio': !exists(json, 'current_leverage_ratio') ? undefined : json['current_leverage_ratio'],
        'allocationType': GrowthAllocationTypeFromJSON(json['allocation_type']),
        'exposureStatus': !exists(json, 'exposure_status') ? undefined : ExposureStatusFromJSON(json['exposure_status']),
        'currentWeight': !exists(json, 'current_weight') ? undefined : json['current_weight'],
        'targetWeight': !exists(json, 'target_weight') ? undefined : json['target_weight'],
        'activeWeight': !exists(json, 'active_weight') ? undefined : json['active_weight'],
        'currentExposure': !exists(json, 'current_exposure') ? undefined : json['current_exposure'],
        'targetExposure': !exists(json, 'target_exposure') ? undefined : json['target_exposure'],
        'activeExposure': !exists(json, 'active_exposure') ? undefined : json['active_exposure'],
        'tradeDate': json['trade_date'],
        'reportStage': ReportStageFromJSON(json['report_stage']),
        'pId': json['p_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'referencePortfolio': !exists(json, 'reference_portfolio') ? undefined : json['reference_portfolio'],
    };
}

export function GrowthAllocationEnrichedToJSON(value?: GrowthAllocationEnriched | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_growth_sleeve': value.targetGrowthSleeve,
        'actual_unencumbered_cash': value.actualUnencumberedCash,
        'current_leverage_ratio': value.currentLeverageRatio,
        'allocation_type': GrowthAllocationTypeToJSON(value.allocationType),
        'exposure_status': ExposureStatusToJSON(value.exposureStatus),
        'current_weight': value.currentWeight,
        'target_weight': value.targetWeight,
        'active_weight': value.activeWeight,
        'current_exposure': value.currentExposure,
        'target_exposure': value.targetExposure,
        'active_exposure': value.activeExposure,
        'trade_date': value.tradeDate,
        'report_stage': ReportStageToJSON(value.reportStage),
        'p_id': value.pId,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
        'reference_portfolio': value.referencePortfolio,
    };
}

